import { useEffect, useState } from "react";

import api, { API_BASE } from "@/lib/api";
import { useSite } from "@/contexts/SiteContext";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";

export default function Diplomas() {
  const { sectionContent } = useSite();
  const c = sectionContent("diplomas");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/public/diplomas").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!c) return null;
  // Fără diplome încărcate → secțiunea nu apare deloc (nu arătăm schele publicului)
  if (items.length === 0) return null;

  const resolve = (d) => d.image_url || (d.image_path ? `${API_BASE}/public/files?path=${encodeURIComponent(d.image_path)}` : "");

  return (
    <section data-testid="diplomas-section" className="py-24 lg:py-32" style={{ background: "var(--ct-surface-2)" }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="gold-rule" />
            <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Acreditări"}</span>
            <span className="gold-rule" />
          </div>
          <h2 data-el="title" data-field="title" className="font-serif text-4xl sm:text-5xl leading-tight">{c.title || "Diplome și certificări"}</h2>
          {c.subtitle && <p data-el="subtitle" data-field="subtitle" className="text-base leading-relaxed mt-4" style={{ color: "var(--ct-text-muted)" }}>{c.subtitle}</p>}
        </div>

        {(
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((d, i) => {
              const src = resolve(d);
              return (
                <Dialog key={d.id}>
                  <DialogTrigger asChild>
                    <button type="button" className="card-premium overflow-hidden group cursor-zoom-in flex flex-col" data-testid={`diploma-${i}`}>
                      <div className="aspect-[3/4] overflow-hidden">
                        <img src={src} alt={d.title || "Diplomă"} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                      </div>
                      {(d.title || d.year || d.issued_by) && (
                        <div className="p-4 text-left">
                          {d.title && <p className="text-sm font-medium truncate">{d.title}</p>}
                          {(d.year || d.issued_by) && (
                            <p className="text-xs mt-0.5" style={{ color: "var(--ct-text-dim)" }}>
                              {[d.issued_by, d.year].filter(Boolean).join(" · ")}
                            </p>
                          )}
                        </div>
                      )}
                    </button>
                  </DialogTrigger>
                  <DialogContent className="max-w-3xl p-0 bg-transparent border-0">
                    <img src={src} alt={d.title || "Diplomă"} className="w-full h-auto rounded-2xl" />
                    <div className="text-center text-sm mt-4 px-4 pb-4">
                      {d.title && <p className="font-serif text-xl" style={{ color: "var(--ct-text-inverse)" }}>{d.title}</p>}
                      {(d.year || d.issued_by) && (
                        <p className="text-xs mt-1" style={{ color: "var(--ct-gold)" }}>
                          {[d.issued_by, d.year].filter(Boolean).join(" · ")}
                        </p>
                      )}
                      {d.description && <p className="text-sm mt-3" style={{ color: "var(--ct-text-inverse)" }}>{d.description}</p>}
                    </div>
                  </DialogContent>
                </Dialog>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
